"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoursesResults = exports.SearchResultsCoursesList = exports.SearchResultCourse = exports.LearningDataService = void 0;
var tslib_1 = require("tslib");
var json2typescript_1 = require("json2typescript");
var search_1 = require("src/search");
var FilterableList_1 = require("Views/Partials/Components/FilterableList");
var LearningDataService = /** @class */ (function () {
    function LearningDataService(searchUrl, searchParams) {
        var _this = this;
        this.getDataForLearningComponent = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.searchApi
                        .doSearch(this.searchParams, CoursesResults)
                        .then(function (data) {
                        return _this.processSuccessResult(data);
                    })
                        .catch(function (error) {
                        return _this.processFailResult(error);
                    })];
            });
        }); };
        this.processSuccessResult = function (data) {
            var coursesData = data.documentList.documents;
            if (coursesData && coursesData.length > 0) {
                return {
                    coursesData: data.documentList.documents,
                    statusCode: FilterableList_1.ListStatusCode.success,
                };
            }
            return {
                coursesData: [],
                statusCode: FilterableList_1.ListStatusCode.zeroResults,
            };
        };
        this.processFailResult = function (error) {
            if (_this.isCommunicationError(error)) {
                return {
                    statusCode: FilterableList_1.ListStatusCode.communicationError,
                    coursesData: [],
                };
            }
            throw new Error(error);
        };
        this.isCommunicationError = function (error) {
            return error && error.name === search_1.SEARCH_API_ERROR;
        };
        this.searchApi = new search_1.CoursesSearcherApi({
            url: searchUrl,
        });
        this.searchParams = searchParams;
    }
    return LearningDataService;
}());
exports.LearningDataService = LearningDataService;
/* tslint:disable */
var SearchResultCourse = /** @class */ (function () {
    function SearchResultCourse() {
        this.id = undefined;
        this.name = undefined;
        this.type = undefined;
        this.language = undefined;
        this.description = undefined;
        this.learningType = undefined;
        this.deliveryTypes = undefined;
        this.duration = undefined;
        this.url = undefined;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('id', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultCourse.prototype, "id", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('title', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultCourse.prototype, "name", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('course_type', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultCourse.prototype, "type", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('language', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultCourse.prototype, "language", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('description', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultCourse.prototype, "description", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('learning_type', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultCourse.prototype, "learningType", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('delivery_types', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultCourse.prototype, "deliveryTypes", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('duration', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultCourse.prototype, "duration", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('url', String, true),
        tslib_1.__metadata("design:type", String)
    ], SearchResultCourse.prototype, "url", void 0);
    SearchResultCourse = tslib_1.__decorate([
        json2typescript_1.JsonObject('SearchResultCourse')
    ], SearchResultCourse);
    return SearchResultCourse;
}());
exports.SearchResultCourse = SearchResultCourse;
var SearchResultsCoursesList = /** @class */ (function () {
    function SearchResultsCoursesList() {
        this.documents = undefined;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('documents', [SearchResultCourse]),
        tslib_1.__metadata("design:type", Array)
    ], SearchResultsCoursesList.prototype, "documents", void 0);
    SearchResultsCoursesList = tslib_1.__decorate([
        json2typescript_1.JsonObject('SearchResultsCoursesList')
    ], SearchResultsCoursesList);
    return SearchResultsCoursesList;
}());
exports.SearchResultsCoursesList = SearchResultsCoursesList;
var CoursesResults = /** @class */ (function () {
    function CoursesResults() {
        this.documentList = undefined;
        this.courses = undefined;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('documentList', SearchResultsCoursesList),
        tslib_1.__metadata("design:type", SearchResultsCoursesList)
    ], CoursesResults.prototype, "documentList", void 0);
    CoursesResults = tslib_1.__decorate([
        json2typescript_1.JsonObject('CoursesResults')
    ], CoursesResults);
    return CoursesResults;
}());
exports.CoursesResults = CoursesResults;
/* tslint:enable */
